module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-22.0b7863a7.png";